<template>
  <div id="app">
    <transition name="slide">
      <router-view></router-view>
    </transition>
    <Loading v-if="this.$store.state.isLoading" />
  </div>
</template>
<script>
import Loading from './components/Loading.vue';

export default {
  data() {
    return {
      checkTouch: false
    };

  },
  components: {
    Loading
  },
  methods: {
    RefreshHomePage() {
      let cont = 15;

      setInterval(() => {
        document.addEventListener("click", () => {
          cont = 15;
          this.checkTouch = true;
        });
        // if (this.checkTouch == true) {
        //   if (cont == 0) {
        //     window.location.href = "http://localhost:8081/#/home";
        //     // this.$router.push("/home");
        //   } else {
        //     cont--;
        //   }
        // } else {
        //   this.checkTouch = false;
        // }
      }, 1000);
    }
  },
  mounted() {
    this.RefreshHomePage();
  }
};
</script>
<style>
.slide-leave-active {
  transition: opacity 0.25s ease;
  opacity: 0;
  animation: slide-out 0.25s ease-out forwards;
}

.slide-leave {
  opacity: 1;
  transform: translateX(0);
}

.slide-enter-active {
  animation: slide-in 0.25s ease-out forwards;
}

@keyframes slide-out {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-30px);
  }
}

@keyframes slide-in {
  0% {
    transform: translateX(30px);
  }
  100% {
    transform: translateX(0);
  }
}
</style>